import { type PreOrderLine } from "../__app.collect.orders.create/orders-create-context";
import { lineDueInclVat } from "../__app.collect.orders.create/price-pre-order-line";

export function sumPreOrderLines(lines: PreOrderLine[]) {
  return lines.reduce(
    (totals, line) => ({
      totalInclVat: totals.totalInclVat + lineDueInclVat(line),
      depositTotalInclVat: totals.depositTotalInclVat + line.depositInclVat
    }),
    { totalInclVat: 0, depositTotalInclVat: 0 }
  );
}
